import { CrudForm } from '../shared/CrudPage';
import { branchService } from '@kss/api';
import type { Branch, BranchCreate, BranchFilter } from '@kss/api';

type F = {
  code: string;
  name: string;
  description: string;
  status: string;
  remarks: string;
  branchType: string;
  address: string;
  city: string;
  state: string;
  postalCode: string;
  country: string;
  phone: string;
  email: string;
  isActive: boolean;
};

const empty: F = {
  code: '',
  name: '',
  description: '',
  status: '',
  remarks: '',
  branchType: '',
  address: '',
  city: '',
  state: '',
  postalCode: '',
  country: 'IN',
  phone: '',
  email: '',
  isActive: true,
};

export default function NewBranch() {
  return (
    <CrudForm<Branch, BranchCreate, BranchFilter, F>
      title="branch"
      service={branchService}
      idKey="branchId"
      basePath="/panel/branchs"
      emptyForm={empty}
      fields={[
        { key: 'code', label: 'Code', placeholder: 'BR-001 (auto if empty)' },
        { key: 'name', label: 'Name', required: true },
        { key: 'branchType', label: 'Branch type', placeholder: 'Head office, Outlet, Warehouse' },
        { key: 'phone', label: 'Phone', type: 'tel' },
        { key: 'email', label: 'Email', type: 'email' },
        { key: 'address', label: 'Address' },
        { key: 'city', label: 'City' },
        { key: 'state', label: 'State' },
        { key: 'postalCode', label: 'Postal code' },
        { key: 'country', label: 'Country' },
        { key: 'description', label: 'Description' },
        { key: 'isActive', label: 'Status', type: 'status' },
      ]}
      fromEntity={(r) => ({
        code: ((r as unknown as Record<string, unknown>).code ?? '') as string,
        name: ((r as unknown as Record<string, unknown>).name ?? '') as string,
        description: ((r as unknown as Record<string, unknown>).description ?? '') as string,
        status: ((r as unknown as Record<string, unknown>).status ?? '') as string,
        remarks: ((r as unknown as Record<string, unknown>).remarks ?? '') as string,
        branchType: ((r as unknown as Record<string, unknown>).branchType ?? '') as string,
        address: ((r as unknown as Record<string, unknown>).address ?? '') as string,
        city: ((r as unknown as Record<string, unknown>).city ?? '') as string,
        state: ((r as unknown as Record<string, unknown>).state ?? '') as string,
        postalCode: ((r as unknown as Record<string, unknown>).postalCode ?? '') as string,
        country: ((r as unknown as Record<string, unknown>).country ?? '') as string,
        phone: ((r as unknown as Record<string, unknown>).phone ?? '') as string,
        email: ((r as unknown as Record<string, unknown>).email ?? '') as string,
        isActive: !!r.isActive,
      })}
      toEntity={(f, id) => ({
        branchId: id,
        code: f.code ? f.code : undefined,
        name: f.name ? f.name : undefined,
        description: f.description ? f.description : undefined,
        status: f.status ? f.status : undefined,
        remarks: f.remarks ? f.remarks : undefined,
        branchType: f.branchType ? f.branchType : undefined,
        address: f.address ? f.address : undefined,
        city: f.city ? f.city : undefined,
        state: f.state ? f.state : undefined,
        postalCode: f.postalCode ? f.postalCode : undefined,
        country: f.country ? f.country : undefined,
        phone: f.phone ? f.phone : undefined,
        email: f.email ? f.email : undefined,
        isActive: f.isActive,
      } as Branch)}
      validate={(f) => (!f.name.trim() ? 'Name is required' : null)}
    />
  );
}
